import authServiceReducer from 'modules/auth/services/reducers';
import turnServiceReducer from 'modules/turn/services/reducers';
import userServiceReducer from 'modules/user/services/reducers';
import uiServiceReducer from 'services/UI/reducer';
import shopServiceReducer from 'services/shop/reducers';

const rootReducer = {
  ui: uiServiceReducer,
  user: userServiceReducer,
  auth: authServiceReducer,
  shop: shopServiceReducer,
  turn: turnServiceReducer,
};

export default rootReducer;
